import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { FaLungs, FaHeart, FaFire, FaHeartbeat as FaHeartbeatIcon } from "react-icons/fa";

const StatisticsOverview = ({ stats, timeRangeType }) => {
  const getStatLabel = () => {
    switch(timeRangeType) {
      case 'today': return 'Today';
      case 'week': return 'Weekly';
      case 'month': return 'Monthly';
      default: return '';
    }
  };

  const statConfigs = [
    {
      key: 'respiratory',
      icon: FaLungs,
      color: 'info',
      label: 'Respiratory Rate',
      value: stats.respiratory.avg.toFixed(1),
      subLabel: getStatLabel() + (timeRangeType === 'today' ? '' : ' Avg')
    },
    {
      key: 'heart',
      icon: FaHeart,
      color: 'danger',
      label: 'Heart Rate',
      value: stats.heart.avg.toFixed(0),
      subLabel: getStatLabel() + (timeRangeType === 'today' ? '' : ' Avg')
    },
    {
      key: 'energy',
      icon: FaFire,
      color: 'warning',
      label: 'Active Energy',
      value: stats.energy.total.toFixed(1),
      subLabel: getStatLabel() + (timeRangeType === 'today' ? '' : ' Total')
    },
    {
      key: 'hrv',
      icon: FaHeartbeatIcon,
      color: 'success',
      label: 'HRV',
      value: stats.hrv.avg.toFixed(1),
      subLabel: getStatLabel() + (timeRangeType === 'today' ? '' : ' Avg')
    }
  ];

  return (
    <Row className="mb-4">
      {statConfigs.map((config) => (
        <Col md={3} key={config.key}>
          <Card className="text-center border-0 shadow-sm h-100">
            <Card.Body>
              <div className="d-flex flex-column align-items-center">
                <div className={`p-3 rounded-circle bg-${config.color} bg-opacity-10 mb-2`}>
                  <config.icon size={24} className={`text-${config.color}`} />
                </div>
                <h3 className={`text-${config.color} mb-0`}>{config.value}</h3>
                <small className="text-muted">{config.label}</small>
                <div className="small text-muted mt-1">{config.subLabel}</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatisticsOverview;